import { render, staticRenderFns } from "./TopupPage.vue?vue&type=template&id=5205e6f4&scoped=true"
import script from "./TopupPage.vue?vue&type=script&lang=js"
export * from "./TopupPage.vue?vue&type=script&lang=js"
import style0 from "./TopupPage.vue?vue&type=style&index=0&id=5205e6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5205e6f4",
  null
  
)

export default component.exports